import { Controller } from "@hotwired/stimulus"

// Opens a lazy turbo-frame and fetches it FRESH every time. Appends a
// cache-buster to the URL so the frame reloads even when the address is
// otherwise unchanged (Turbo skips a same-src navigation) and no cache layer
// can hand back a stale copy. This matters most on iOS WKWebView, which can
// serve a cached response for an in-page fetch despite a no-store header — so
// the recipe grocery preview was showing pre-add "On your list" state there
// even though the web behaved correctly.
export default class extends Controller {
  static values = { url: String, frame: String }

  open(event) {
    event.preventDefault()
    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    const separator = this.urlValue.includes("?") ? "&" : "?"
    frame.src = `${this.urlValue}${separator}_=${Date.now()}`
  }
}
